// Shared by the job and run lists, so both read the same.

export function formatTimestamp(value: number | null): string {
  if (!value) return "—";
  return new Date(value).toLocaleString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

// From when the work started to when it ended, or to now while it is running.
export function formatDuration(
  startedAt: number | null,
  finishedAt: number | null,
): string {
  if (!startedAt) return "—";
  const seconds = Math.max(0, Math.round(((finishedAt ?? Date.now()) - startedAt) / 1000));
  if (seconds < 60) return `${seconds} s`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} min ${seconds % 60} s`;
  return `${Math.floor(minutes / 60)} h ${minutes % 60} min`;
}
